import { List, ListItem, ListItemButton } from 'components/ui';
import theme from 'theme';
import styled from 'styled-components';

export const IndexListItemButton = styled(ListItemButton)`
  background-color: ${theme.palette.primary.white};
  border: 1px solid ${theme.palette.divider};
  display: block;

  
  ${theme.breakpoints.up('lg')} {
    &:not(.bordered) {
      border-top: none;

      &:last-child {
        border-radius: 0 0 ${theme.radius.card} ${theme.radius.card};
      }
    }
  }

  ${theme.breakpoints.down('lg')} {
    border-radius: ${theme.radius.card};
    margin-bottom: ${theme.padding.content};
  }

  &.bordered {
    border-radius: ${theme.radius.card};
    margin-top: ${theme.padding.content};
  }

  &:hover {
    background-color: ${theme.palette.action.hover};
  }

  &.overdue::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    background-color: ${theme.palette.error.main};
  }
  &.incoming::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    background-color: ${theme.palette.warning.main};
  }
`;

export const IndexListItem = styled(ListItem)`
  border: 1px solid ${theme.palette.divider};
  border-top: none;
  background-color: ${theme.palette.primary.white};
  display: block;

  &:last-child {
    border-radius: 0 0 ${theme.radius.card} ${theme.radius.card};
  }
`;

export const FieldsList = styled(List)`
  display: inline-grid;
  li {
    padding: 0;
  }
`;

export const FieldsListItem = styled(ListItem)`
  > span {
    padding-right: ${theme.padding.content};
  }
`;

export const IndexListItemHeader = styled(ListItem)`
  display: block;
  background-color: ${theme.palette.primary.gray};
  border-radius: ${theme.radius.card} ${theme.radius.card} 0 0;
  text-transform: uppercase;
  font-size: ${theme.typography.fontSize}px;
  color: ${theme.palette.text.secondary};
  border: 1px solid ${theme.palette.divider};
`;
